// extracted by mini-css-extract-plugin
module.exports = {"root":"RegisterEmailError_root__17SQa","modalHeader":"RegisterEmailError_modalHeader__1uYZw"};